import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider, useAuth } from "./lib/auth";
import { ThemeProvider } from "./lib/theme";

import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import Positioning from "./pages/Positioning";
import Workspace from "./pages/Workspace";
import Content from "./pages/Content";
import Calendar from "./pages/Calendar";
import Funnel from "./pages/Funnel";
import Performance from "./pages/Performance";
import Frameworks from "./pages/Frameworks";
import SystemMap from "./pages/SystemMap";
import Settings from "./pages/Settings";
import AcceptInvite from "./pages/AcceptInvite";
import DashboardLayout from "./layouts/DashboardLayout";

function Protected({ children }) {
  const { user, loading, activeBrand } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted font-mono text-xs">carregando…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (!activeBrand && location.pathname !== "/onboarding") return <Navigate to="/onboarding" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/invite/:token" element={<AcceptInvite />} />
      <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
      <Route path="/dashboard" element={<Protected><DashboardLayout><Dashboard /></DashboardLayout></Protected>} />
      <Route path="/posicionamento" element={<Protected><DashboardLayout><Positioning /></DashboardLayout></Protected>} />
      <Route path="/workspace" element={<Protected><DashboardLayout><Workspace /></DashboardLayout></Protected>} />
      <Route path="/conteudo" element={<Protected><DashboardLayout><Content /></DashboardLayout></Protected>} />
      <Route path="/calendario" element={<Protected><DashboardLayout><Calendar /></DashboardLayout></Protected>} />
      <Route path="/funil" element={<Protected><DashboardLayout><Funnel /></DashboardLayout></Protected>} />
      <Route path="/performance" element={<Protected><DashboardLayout><Performance /></DashboardLayout></Protected>} />
      <Route path="/frameworks" element={<Protected><DashboardLayout><Frameworks /></DashboardLayout></Protected>} />
      <Route path="/sistema" element={<Protected><DashboardLayout><SystemMap /></DashboardLayout></Protected>} />
      <Route path="/configuracoes" element={<Protected><DashboardLayout><Settings /></DashboardLayout></Protected>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" toastOptions={{ style: { background: "var(--panel)", color: "var(--txt)", border: "1px solid var(--border)" } }} />
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
